import { ReactElement } from 'react';
import { Text } from '@cad-arc';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useEventMetadataStore } from './event-panel-form/event-metadata';

export const EventStaffCountDisplay = ({
    eventHasUnits,
}: {
    eventHasUnits: boolean;
}): ReactElement | null => {
    const { staffCountEnabled } = useEnabledFeatures();
    const { staffCount } = useEventMetadataStore().state.metadata ?? {};

    if (!staffCountEnabled || !eventHasUnits) {
        return null;
    }

    return (
        <Text
            as="span"
            color="tertiary"
            fontWeight="normal"
            fontSize="sm"
            style={{
                alignSelf: 'start',
            }}
        >
            Staff Count:{' '}
            <Text as="span" color="primary" fontWeight="semibold">
                {staffCount ?? 0}
            </Text>
        </Text>
    );
};
